/* eslint-disable */
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import "../../styles/candidate_nav.css";
import commonLabels from "../../common/labels/common_en.json";

const HomePageNav = () => {
    let accessToken = useSelector(state => state.loginReducer.accessToken);
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    const location = useLocation();

    if (accessToken || (session && session?.jwtResponse?.token)) {
        return null;
    } else {
        return (
            <nav className="navbar navbar-expand-lg navbar-dark bg-color-third justify-content-end h46">
                <div className="container-fluid">
                    <ul className="navbar-nav d-flex flex-row ms-auto">
                        <li className="text-center me-2">
                            <Link to="/candidate/login" className={`nav-link ${location.pathname === "/candidate/login" ? "active" : ""}`}>
                                <span className="text-third-nav ms-1" data-toggle="tab">{commonLabels.COMMON.HOME}</span>
                            </Link>
                        </li>
                        {(location.pathname === "/candidate/registration") && <>
                            <li className="text-center me-2">
                                <Link to="/candidate/registration" className={`nav-link ${location.pathname === "/candidate/registration" ? "active" : ""}`}>
                                    <span className="text-third-nav ms-1" data-toggle="tab">{commonLabels.SIGN_UP.REGISTER_HEADER}</span>
                                </Link>
                            </li>
                        </>
                        }
                        {/* <li className="text-center me-2">
                            <Link to="/candidate/grievance" className={`nav-link ${location.pathname === "/candidate/grievance" ? "active" : ""}`}>
                                <span className="text-third-nav ms-1" data-toggle="tab">{commonLabels.SIGN_UP.GRIEVANCE}</span>
                            </Link>
                        </li> */}
                     
                        <li className="text-center me-2">
                            <Link target="_blank"
                            rel="noopener noreferrer"
                             to={commonLabels.HOME.BPSC_OFFICIAL_WEBSITE_LINK} className={`nav-link ${location.pathname === commonLabels.HOME.BPSC_OFFICIAL_WEBSITE_LINK ? "active" : ""}`}>
                                <span className="text-third-nav">{commonLabels.HOME.BPSC_OFFICIAL_WEBSITE}</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
};

export default HomePageNav;